<template>
  <BaseChartPanel
    :title="t('categories_dynamic_chart.title')"
    :date="date"
    :chart-height="stylesChart.heightAreaChart"
    :chart-key="refreshCounter"
    :chart-options="chartOptions"
    :series="allCategories?.length ? toRaw(series) : []"
    @refresh="loadData"
    @update:date="date = $event"
  >
    <template #controls>
      <ChartFilterDropdown
        v-if="allCategories?.length"
        :chart-type="2"
        :active-store="statStorage"
        :date="date"
        :show-chart-chooser="false"
        stop-load-on-clear
        @clear="clearRubrics"
      />
    </template>
  </BaseChartPanel>
</template>

<script setup>
import { computed, onMounted, ref, toRaw } from "vue";
import { useNewsStatDynamicCategoryStore } from "@/store/Analytic/chart/news-stat-dynamic-category";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import { stylesChart } from "@/tools/tooltipChart";
import ChartFilterDropdown from "./blocks/ChartFilterDropdown.vue";
import useFilterDate from "@/mixins/apexChart/filterDate";
import useAreaChart from "@/mixins/apexChart/areaChart";
import { t } from "@/controllerLK/AvalLocalization";
import BaseChartPanel from "./BaseChartPanel.vue";

const statStorage = useNewsStatDynamicCategoryStore();
const newsStorage = useNewsFeedStore();
const refreshCounter = ref(0);

const categories = computed(() => {
  const labelsSet = new Set();
  (statStorage?.items || []).forEach((item) => {
    if (item?.data) {
      item.data.forEach((point) => {
        labelsSet.add(point.date);
      });
    }
  });
  return Array.from(labelsSet).sort((a, b) => new Date(a) - new Date(b));
});

const allCategories = computed(() => newsStorage.filterCategories.list);

const series = computed(() => {
  if (!statStorage.items?.length) return [];

  // Получаем все уникальные даты из всех серий
  const allDates = categories.value;

  return (statStorage.items || []).map((item) => {
    const categoryObj = allCategories.value.find((cat) => cat.id == item.name);
    const categoryName = categoryObj?.name ? categoryObj.name : item.id;

    // Создаем Map для быстрого поиска значений по датам
    const dataMap = new Map();
    item.data.forEach(point => {
      dataMap.set(point.date, point.count);
    });

    // Создаем данные для всех дат
    const seriesData = allDates.map(date => ({
      x: date,
      y: dataMap.get(date) || null // null вместо 0 для пропущенных значений
    }));

    return {
      name: categoryName,
      data: seriesData
    };
  });
});

const { chartOptions } = useAreaChart(
  {
    titleText: t("categories_dynamic_chart.title"),
  },
  categories,
  series
);

const { date } = useFilterDate(loadData);

onMounted(async () => {
  await loadData();
});

async function loadData() {
  await statStorage.loadStat(date.value?.[0], date.value?.[1]);
}

const clearRubrics = () => {
  statStorage.items = [];
  refreshCounter.value++;
  chartOptions.value = {
    ...chartOptions.value,
    noData: { text: t("common_chart.no_data.short_text") },
  };
};
</script>